export default {
  nodeConfig: {
    common: {
      placeholder: 'Please enter',
      selectPlaceholder: 'Please select',
      noData: 'No data',
      noMatch: 'No match',
      searchNode: 'Search Node',
      remove: 'Remove',
      oneClickDeploy: 'One-Click Deploy',
      externalConfiguration: 'External Configuration',
      managed: 'Managed',
      external: 'External',
    },
    panel: {
      unnamedNode: 'Unnamed Node',
      namePlaceholder: 'Please enter node name',
      noDescription: 'No description',
      descPlaceholder: 'Please enter node description',
      applyTemplate: 'Apply Template',
      operationGuide: 'Operation Guide',
      loading: 'Loading...',
      templateNamePlaceholder: 'Please enter template name',
      saveTemplate: 'Save Template',
      cancel: 'Cancel',
      save: 'Save',
      message: {
        checkForm: 'Please check form validation',
        saveTemplateSuccess: 'Save template success',
        saveTemplateFailed: 'Save template failed',
      },
      inputVars: 'Input Variables',
      outputVars: 'Output Variables',
    },
    nodeSelector: {
      basicNodes: 'Basic Nodes',
      buildInTools: 'Build in Tools',
      searchNode: 'Search Node',
      searchTool: 'Search Tool',
      searchPlaceholder: 'Search nodes, plugins, workflows',
      noSearchResults: 'No search results',
      noAvailableNodes: 'No nodes available',
      nodeComingSoon: 'This node is coming soon, stay tuned',
      groups: {
        'ai_knowledge': '',
        'start': 'Start',
        'logic': 'Logic',
        'code': 'Code',
        'output': 'Output',
        'utilities': 'Utilities',
        'dedicated_database': 'Dedicated Database',
        'cloud_storage': 'Cloud Storage',
        'messages': 'Messages',
        'search': 'Search',
        'nlp_pipeline': 'NLP Pipeline',
        'image': 'Image',
        'audio': 'Audio',
        'video': 'Video',
        '3d': '3D',
        'content_safe': 'Content Safe',
      },
    },
    varSelect: {
      inputPlaceholder: 'Please enter',
      inputTagPlaceholder: 'Please enter, press Enter to add',
      cascaderPlaceholder: 'Please select predecessor node variable',
      varUndefined: 'Variable undefined',
      switchTip: 'Toggle between variable and direct input',
    },
    validation: {
      predecessorVarUndefined: 'Predecessor node variable undefined',
      modelNameRequired: 'Model name cannot be empty',
      promptRequired: 'User prompt cannot be empty',
      modelRequired: 'Tokenizer model cannot be empty',
      modeRequired: 'Tokenizer mode cannot be empty',
      contentVarRequired: 'Content to be detected cannot be empty',
      codeRequired: 'Code cannot be empty',
      javascriptCodeRequired: 'JavaScript code cannot be empty',
      pythonCodeRequired: 'Python code cannot be empty',
      operationRequired: 'Operation type cannot be empty',
      databaseRequired: 'Database cannot be empty',
      connectionRequired: 'Connection configuration cannot be empty',
      databaseConnectionRequired:
        'Database connection configuration cannot be empty',
      redisConnectionRequired: 'Redis connection configuration cannot be empty',
      loopTypeRequired: 'Loop type cannot be empty',
      entryNodesRequired: 'At least one entry node must be configured',
      subWorkflowRequired: 'Sub workflow cannot be empty',
      tokenModeRequired: 'Token operation mode cannot be empty',
      knowledgeIdRequired: 'Knowledge base ID cannot be empty',
      itemsRequired: 'At least one retrieval item must be configured',
    },
    varTable: {
      outputType: 'Output Type',
      noVars: 'No variables',
      typeText: 'Text',
      typeMarkdown: 'Markdown',
      typeJson: 'JSON',
      addVar: 'Add Variable',
    },
    varRecursive: {
      varName: 'Variable Name',
      varNamePlaceholder: 'Please enter variable name',
      type: 'Type',
      addChild: 'Add child variable',
      delete: 'Delete',
      varValue: 'Variable Value',
      varValuePlaceholder: 'Please enter variable value',
      copySuccess: 'Variable name copied to clipboard',
      copyFailed: 'Copy failed, please copy manually',
    },
    varType: {
      placeholder: 'Variable Type',
      string: 'String',
      number: 'Number',
      boolean: 'Boolean',
      time: 'Time',
      array: 'Array',
      object: 'Object',
    },
    exceptionHandle: {
      header: 'Exception Handling',
      maxRetries: 'Max Retries',
      maxRetriesTooltip: '0 means no retry, max retries is 5',
      retryDelay: 'Retry Interval',
      retryDelayTooltip: 'Default 0, unit: second',
      unitSecond: 's',
      timeout: 'Timeout',
      timeoutTooltip: 'Timeout range 0.1-600s',
      retryType: 'Exception Judgment',
      retryTypeTooltip:
        'Default: Timeout or system exception; Custom: Based on timeout and system exception, supports using custom code to judge whether output variables meet requirements',
      retryTypeDefault: 'Default',
      retryTypeCustom: 'Custom',
      customRetryCode: 'Custom Exception Judgment Code',
    },
    llm: {
      header: 'Model Configuration',
      modelPlaceholder: 'Please select model',
      paramsHeader: 'Model Parameter Configuration',
      temperature: 'Temperature',
      maxTokens: 'Max Tokens',
      topP: 'Top P',
      topK: 'Top K',
      streaming: 'Streaming',
      thinking: 'Enable Thinking',
      jsonFormat: 'JSON Format',
      strictMode: 'Strict Mode',
    },
    connection: {
      header: 'Connection Configuration',
      tooltip: 'Supports external sources, optional',
      host: 'Host',
      hostPlaceholder: 'Please enter host IP or domain',
      port: 'Port',
      portPlaceholder: 'Please enter port',
      username: 'Username',
      usernamePlaceholder: 'Please enter username',
      password: 'Password',
      passwordPlaceholder: 'Please enter password',
    },
    condition: {
      and: 'AND',
      or: 'OR',
      addCondition: 'Add Condition',
      maxDepthReached: 'Max nesting level reached ({depth} levels)',
      addChildGroup: 'Add Subgroup',
      deleteGroup: 'Delete Group',
      delete: 'Delete',
      emptyExpression: '(Empty Expression)',
    },
    sql: {
      simpleMode: 'Simple Mode',
      advancedMode: 'Advanced Mode',
      selectFields: 'Select Fields',
      allFields: 'All Fields (*)',
      orderBy: 'Order By',
      asc: 'Ascending',
      desc: 'Descending',
      delete: 'Delete',
      addSort: 'Add Sort',
      groupBy: 'Group By',
      groupByPlaceholder: 'Select group by field (optional)',
      countField: 'Count Field',
      countAll: 'All (*)',
      countDistinct: 'Distinct Count (DISTINCT)',
      sqlTemplate: 'SQL Template',
      templatePlaceholder: 'Select common template (optional)',
      addColumn: 'Add Column',
      dropColumn: 'Drop Column',
      createIndex: 'Create Index',
      dropIndex: 'Drop Index',
      truncate: 'Truncate Table',
      sqlStatement: 'SQL Statement',
      sqlPlaceholderSimple:
        'Please enter SQL statement or select from template',
      sqlPlaceholderAdvanced:
        'Please enter the SQL query statement to be executed. By inserting {variable_name}, you can reference input parameters.\nExample:\nselect * from table_name\nwhere name = {name}',
      generatedSql: 'Generated SQL:',
      copy: 'Copy',
      empty: '(Empty)',
      configureHint: '(Please configure query conditions)',
      quickInsert: 'Quick Insert:',
    },

    data: {
      documentExtractor: {
        sourceType: 'Source Type',
        sourceTypePlaceholder: 'Select source type',
        sources: {
          file: 'Local File',
          url: 'URL Address',
          base64: 'Base64 Data',
        },
        docType: 'Document Type',
        docTypePlaceholder: 'Select document type',
        docTypes: {
          auto: 'Auto',
          pdf: 'PDF',
          docx: 'Word (docx)',
          xlsx: 'Excel (xlsx)',
          txt: 'Text',
          html: 'HTML',
          image: 'Image',
          json: 'JSON',
          csv: 'CSV',
        },
        uploadFile: 'Upload File',
        selectFile: 'Select File',
        filePath: 'File Path',
        filePathPlaceholder: 'Enter file path on server',
        filePathFromVar: 'From Variable',
        filePathVarPlaceholder: 'Select variable with path',
        urlAddress: 'URL Address',
        urlPlaceholder: 'Enter URL',
        inputVar: 'Input Variable',
        inputVarPlaceholder: 'Select variable with Base64 data',
        configHeader: 'Source Config',
        extractHeader: 'Extraction Config',
        encoding: 'Encoding',
        encodingPlaceholder: 'Select encoding',
        maxPages: 'Max Pages',
        noLimit: '0 means no limit',
        timeout: 'Timeout (s)',
        extractMetadata: 'Extract Metadata',
        extractImages: 'Extract Images',
        ocrHeader: 'OCR Config',
        enableOcr: 'Enable OCR',
        ocrProvider: 'OCR Provider',
        ocrProviderPlaceholder: 'Select OCR provider',
        apiKey: 'API Key',
        apiKeyPlaceholder: 'Enter API Key',
        secretKey: 'Secret Key',
        secretKeyPlaceholder: 'Enter Secret Key',
      },
      listOperator: {
        inputConfig: 'Input Config',
        inputVar: 'Input Variable',
        inputVarPlaceholder: 'Select list variable',
        operationConfig: 'Operation Config',
        operationType: 'Operation Type',
        operationTypePlaceholder: 'Select operation type',
        operations: {
          filter: 'Filter',
          sort: 'Sort',
          unique: 'Unique',
          slice: 'Slice',
          reverse: 'Reverse',
          map: 'Map',
          flatten: 'Flatten',
          group_by: 'Group By',
          chunk: 'Chunk',
          count: 'Count',
          sum: 'Sum',
          avg: 'Average',
          min: 'Min',
          max: 'Max',
          first: 'First',
          last: 'Last',
          find: 'Find',
          find_index: 'Find Index',
          every: 'Every',
          some: 'Some',
          concat: 'Concat',
          difference: 'Difference',
          intersect: 'Intersect',
          union: 'Union',
        },
        operationField: 'Field',
        fieldPlaceholder: 'Enter field name',
        secondList: 'Second List',
        secondListPlaceholder: 'Select second list variable',
        groupField: 'Group Field',
        groupFieldPlaceholder: 'Enter group field name',
        filterCondition: 'Filter Condition',
        fieldName: 'Field Name',
        operators: {
          equals: 'Equals',
          not_equals: 'Not Equals',
          gt: 'Greater Than',
          gte: 'Greater Than or Equal',
          lt: 'Less Than',
          lte: 'Less Than or Equal',
          contains: 'Contains',
          starts_with: 'Starts With',
          ends_with: 'Ends With',
          is_empty: 'Is Empty',
          regex: 'Regex Match',
        },
        value: 'Value',
        addCondition: 'Add Condition',
        sortConfig: 'Sort Config',
        sortField: 'Sort Field',
        orders: {
          asc: 'ASC',
          desc: 'DESC',
        },
        addSortField: 'Add Sort Field',
        sliceConfig: 'Slice Config',
        sliceStart: 'Start Index',
        sliceEnd: 'End Index',
        sliceStep: 'Step',
        chunkConfig: 'Chunk Config',
        chunkSize: 'Chunk Size',
      },
      set: {
        varSet: 'Variable Settings',
        setMode: 'Set Mode',
        modes: {
          set: 'Override (set)',
          merge: 'Merge (merge)',
        },
        colName: 'Name',
        colValueType: 'Value Type',
        colValue: 'Value',
        colType: 'Type',
        valueTypes: {
          static: 'Static',
          variable: 'Variable',
          expression: 'Expression',
        },
        placeholderName: 'Variable name',
        placeholderVar: 'Select variable',
        placeholderExp: 'Enter expression',
        placeholderValue: 'Enter value',
        placeholderType: 'Type',
        addVar: 'Add Variable',
      },
      template: {
        configHeader: 'Template Config',
        engine: 'Engine',
        enginePlaceholder: 'Select engine',
        engines: {
          simple: 'Simple Replace',
          go: 'Go Template',
          jinja2: 'Jinja2',
          handlebars: 'Handlebars',
        },
        content: 'Content',
        contentPlaceholder: 'Enter template content',
        // eslint-disable-next-line no-template-curly-in-string
        templatePlaceholder: 'E.g.: Hello, ${name}!',
        syntaxLabel: 'Supported Syntax:',
        // eslint-disable-next-line no-template-curly-in-string
        notSupportVarSyntax: 'Does not support ${var} syntax',
        outputFormat: 'Output Format',
        formats: {
          string: 'String',
          json: 'JSON',
          html: 'HTML',
        },
        escapeHtml: 'Escape HTML',
        strictMode: 'Strict Mode',
        strictModeTip: 'Variable not found will cause error',
        varMapping: 'Variable Mapping',
        colName: 'Name',
        colSource: 'Source',
        placeholderName: 'Variable name',
        placeholderSource: 'Select variable',
        addVar: 'Add Variable',
        syntaxHelp: 'Syntax Help',
        helpSimple: {
          title: 'Simple Syntax:',
          desc: 'Replace with value',
        },
        helpGo: {
          title: 'Go Syntax:',
          output: 'Output value',
          condition: 'Condition',
          loop: 'Loop',
          filter: 'Filter',
        },
        helpJinja2: {
          title: 'Jinja2 Syntax:',
          output: 'Output value',
          condition: 'Condition',
          loop: 'Loop',
          filter: 'Filter',
        },
        helpHandlebars: {
          title: 'Handlebars Syntax:',
          output: 'Output value',
          condition: 'Condition',
          loop: 'Loop',
        },
      },
      transform: {
        inputConfig: 'Input Config',
        inputVar: 'Input Variable',
        inputVarPlaceholder: 'Select variable',
        staticInput: 'Static Input',
        staticInputPlaceholder: 'Or enter static value',
        transformConfig: 'Transform Config',
        transformType: 'Transform Type',
        transformTypePlaceholder: 'Select transform type',
        types: {
          base64_encode: 'Base64 Encode',
          base64_decode: 'Base64 Decode',
          url_encode: 'URL Encode',
          url_decode: 'URL Decode',
          html_encode: 'HTML Entity Encode',
          html_decode: 'HTML Entity Decode',
          hex_encode: 'Hex Encode',
          hex_decode: 'Hex Decode',
          json_parse: 'JSON Parse',
          json_stringify: 'JSON Stringify',
          xml_to_json: 'XML to JSON',
          json_to_xml: 'JSON to XML',
          html_to_text: 'HTML to Text',
          markdown_to_html: 'Markdown to HTML',
          md5: 'MD5',
          sha1: 'SHA1',
          sha256: 'SHA256',
          sha512: 'SHA512',
          aes_encrypt: 'AES Encrypt',
          aes_decrypt: 'AES Decrypt',
          uppercase: 'To Uppercase',
          lowercase: 'To Lowercase',
          trim: 'Trim',
          replace: 'Replace',
          regex_replace: 'Regex Replace',
          split: 'Split',
          join: 'Join',
          substring: 'Substring',
          pad_start: 'Pad Start',
          pad_end: 'Pad End',
          jsonpath: 'JSONPath',
          regex_match: 'Regex Match',
          regex_extract: 'Regex Extract',
          gzip_compress: 'Gzip Compress',
          gzip_decompress: 'Gzip Decompress',
        },
        find: 'Find',
        findPlaceholder: 'String or regex',
        replaceWith: 'Replace With',
        replaceWithPlaceholder: 'Replacement',
        separator: 'Separator',
        separatorPlaceholder: 'Enter separator',
        start: 'Start',
        end: 'End',
        length: 'Length',
        padChar: 'Pad Char',
        padCharPlaceholder: 'Default space',
        aesKey: 'AES Key',
        keyPlaceholder: '16/24/32 bits',
        jsonPath: 'JSONPath',
        jsonPathPlaceholder: 'e.g. $.data.items[0].name',
        regex: 'Regex',
        regexPlaceholder: 'Enter regex',
        groupIndex: 'Group Index',
        outputFormat: 'Output Format',
        formats: {
          string: 'String',
          bytes: 'Bytes',
          base64: 'Base64',
        },
      },
    },
    ai: {
      llm: {
        promptVars: 'Prompt Variables',
        promptConfig: 'Prompt Configuration',
        systemPrompt: 'System Prompt (SYSTEM)',
        systemPromptPlaceholder:
          'Please enter system prompt to define AI role and behavior rules',
        userPrompt: 'User Prompt (USER)',
        userPromptPlaceholder:
          'Please enter user prompt to describe specific tasks and requirements',
        outputVars: 'Output Variables',
      },
      embedding: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select embedding model configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Service Provider',
        providerPlaceholder: 'Please select service provider',
        aliyun: 'Aliyun Tongyi',
        baidu: 'Baidu Wenxin',
        tencent: 'Tencent Hunyuan',
        custom: 'Custom HTTP Service',
        model: 'Model',
        modelPlaceholder: 'Please select model',
        customModelPlaceholder: 'Please enter custom model name',
        batchSize: 'Batch Size',
        timeout: 'Timeout (s)',
        apiHeader: 'API Configuration',
        apiKeyPlaceholder:
          'Please enter API key (optional, uses global config by default)',
        secretKeyPlaceholder: 'Please enter Secret Key',
        endpointPlaceholder: 'Please enter API endpoint URL',
        region: 'Region',
        regionPlaceholder: 'Please enter service region',
        inputVars: 'Input Variables',
        outputVars: 'Output Variables',
      },
      intent: {
        promptVars: 'Prompt Variables',
        promptConfig: 'Prompt Configuration',
        systemPrompt: 'System Prompt',
        systemPromptPlaceholder: 'Please enter system prompt',
        userPrompt: 'User Prompt',
        userPromptPlaceholder: 'Please enter user prompt',
        intentDefinition: 'Intent Definition',
        intentItem: 'Intent',
        name: 'Name',
        namePlaceholder: 'Intent Name',
        description: 'Description',
        descriptionPlaceholder: 'Intent Description',
        exampleQuery: 'Example Queries',
        addExample: 'Add Example',
        addIntent: 'Add Intent',
        outputVars: 'Output Variables',
      },
      stt: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select speech recognition configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Service Provider',
        providerPlaceholder: 'Please select service provider',
        openai: 'OpenAI Whisper',
        aliyun: 'Aliyun Speech Recognition',
        azure: 'Azure Speech Service',
        tencent: 'Tencent Cloud Speech Recognition',
        volcengine: 'Volcengine Speech Recognition',
        google: 'Google Cloud Speech',
        model: 'Model',
        modelPlaceholder: 'Please select model',
        audioSource: 'Audio Source',
        audioSourcePlaceholder: 'Please select audio source',
        url: 'URL Address',
        base64: 'Base64',
        file: 'Local File',
        variable: 'Variable',
        audioVar: 'Audio Variable',
        audioVarPlaceholder: 'Select output variable from predecessor node',
        filePath: 'File Path',
        filePathPlaceholder: 'Please enter the local path of the audio file',
        language: 'Recognition Language',
        languagePlaceholder: 'Please select recognition language',
        autoDetect: 'Auto Detect',
        zh: 'Chinese',
        en: 'English',
        ja: 'Japanese',
        ko: 'Korean',
        es: 'Spanish',
        fr: 'French',
        de: 'German',
        ru: 'Russian',
        prompt: 'Prompt',
        promptPlaceholder:
          'Optional, enter specific words to help improve recognition accuracy',
        hotWords: 'Hot Words',
        hotWordsPlaceholder: 'Enter and press Enter to add hot words',
        responseFormat: 'Response Format',
        responseFormatPlaceholder: 'Please select response format',
        text: 'Plain Text',
        json: 'JSON Format',
        verboseJson: 'Verbose JSON (with timestamps)',
        srt: 'SRT Subtitle',
        vtt: 'VTT Subtitle',
        advancedHeader: 'Advanced Options',
        enablePunctuation: 'Enable Punctuation',
        enableTimestamp: 'Enable Timestamps',
        enableWordLevel: 'Enable Word-level Timestamps',
        apiHeader: 'API Configuration',
        apiKeyPlaceholder:
          'Please enter API key (optional, uses global config by default)',
        endpoint: 'API Endpoint',
        endpointPlaceholder:
          'Please enter API endpoint (optional, uses default)',
        regionPlaceholder: 'Please enter service region',
        timeout: 'Timeout (s)',
        maxRetries: 'Max Retries',
        retryDelay: 'Retry Delay (s)',
        outputVars: 'Output Variables',
      },
      tts: {
        outputFormat: 'Output Format',
        outputFormatPlaceholder: 'Please select output format',
        url: 'URL Link',
        base64: 'Base64 Encoding',
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select text-to-speech configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Service Provider',
        providerPlaceholder: 'Please select service provider',
        openai: 'OpenAI TTS',
        aliyun: 'Aliyun Text-to-Speech',
        azure: 'Azure Text-to-Speech',
        tencent: 'Tencent Cloud Text-to-Speech',
        volcengine: 'Volcengine Text-to-Speech',
        elevenlabs: 'ElevenLabs',
        model: 'Model',
        modelPlaceholder: 'Please select model',
        text: 'TTS Text',
        textPlaceholder: 'Please enter the text to be synthesized',
        textHint:
          'Use {variable} syntax to insert variables, e.g. Hello, {name}!',
        textVars: 'Text Variables',
        textVar: 'Text Variable',
        textVarPlaceholder:
          'Select output variable from predecessor node as text',
        textVarValuePlaceholder: 'Enter a value or select a variable',
        addVar: 'Add Variable',
        voiceConfig: 'Voice Configuration',
        voice: 'Voice',
        voicePlaceholder: 'Please select voice',
        voiceId: 'Voice ID',
        voiceIdPlaceholder: 'Please enter custom voice ID',
        language: 'Language',
        languagePlaceholder: 'Please select language',
        zhCN: 'Chinese (Mandarin)',
        zhTW: 'Chinese (Traditional)',
        enUS: 'English (US)',
        enGB: 'English (UK)',
        jaJP: 'Japanese',
        koKR: 'Korean',
        esES: 'Spanish',
        frFR: 'French',
        deDE: 'German',
        ruRU: 'Russian',
        speed: 'Speed',
        pitch: 'Pitch',
        low: 'Low',
        normal: 'Normal',
        high: 'High',
        volume: 'Volume',
        mute: 'Mute',
        emotion: 'Emotion',
        emotionPlaceholder: 'Please select emotion style',
        neutral: 'Neutral',
        happy: 'Happy',
        sad: 'Sad',
        angry: 'Angry',
        calm: 'Calm',
        outputHeader: 'Output Configuration',
        audioFormat: 'Audio Format',
        audioFormatPlaceholder: 'Please select audio format',
        sampleRate: 'Sample Rate',
        sampleRatePlaceholder: 'Please select sample rate',
        timeoutHeader: 'Timeout Configuration',
        apiHeader: 'API Configuration',
        apiKeyPlaceholder:
          'Please enter API key (optional, uses global config by default)',
        endpoint: 'API Endpoint',
        endpointPlaceholder:
          'Please enter API endpoint (optional, uses default)',
        regionPlaceholder: 'Please enter Azure region',
        timeout: 'Timeout (s)',
        maxRetries: 'Max Retries',
        retryDelay: 'Retry Delay (s)',
        outputVars: 'Output Variables',
      },
      contentSafe: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select content safety configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Tool Provider',
        providerPlaceholder: 'Please select tool provider',
        aliyun: 'Aliyun AI Content Guard',
        checkType: 'Check Type',
        checkTypePlaceholder: 'Please select check type',
        querySecurityCheck: 'Input Content Check',
        responseSecurityCheck: 'Output Content Check',
        querySecurityCheckCb: 'Overseas Input Content Check',
        responseSecurityCheckCb: 'Overseas Output Content Check',
        inputHeader: 'Input Configuration',
        selectStringVarPlaceholder: 'Please select String type variable',
        contentVar: 'Content',
        contentTooltip:
          'String type, text to be detected, at least one item is required',
        contentPlaceholder: 'Please select String type variable',
        chatId: 'Chat Id',
        chatIdTooltip:
          'String type, identifier for one round of user input + model output interaction, optional',
        outputVars: 'Output Variables',
        outputs: {
          Advice: 'Standard advice returned when calling detection service',
          Result:
            'Results of content compliance risk tags, confidence scores, etc.',
          SensitiveResult:
            'Results of sensitive content risk tags, sensitive samples, etc.',
          AttackResult:
            'Results of attack content risk tags, confidence scores, etc.',
          RiskLevel:
            'Content compliance risk level, includes: high, medium, low, none',
          SensitiveLevel:
            'Sensitivity level, includes: S0, S1, S2, S3, S4, higher is more sensitive',
          AttackLevel: 'Attack level, includes: high, medium, low, none',
        },
      },
      text_to_image: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select image generation configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Service Provider',
        providerPlaceholder: 'Please select service provider',
        providerRequired: 'Please select service provider',
        model: 'Model',
        modelPlaceholder: 'Please select model',
        size: 'Image Size',
        sizePlaceholder: 'Please select image size',
        landscape: 'Landscape',
        portrait: 'Portrait',
        n: 'Generate Count',
        count: 'Generate Count',
        promptHeader: 'Prompt Configuration',
        prompt: 'Positive Prompt',
        promptPlaceholder:
          'Please enter image generation prompt, you can use {varName} to reference variables defined above',
        promptHint:
          'Use {varName} syntax to insert variables, e.g., A {style} painting of {subject}',
        promptVar: 'Prompt Variable',
        promptVarPlaceholder:
          'Select output variable from predecessor node as prompt',
        promptVarValuePlaceholder: 'Enter value or select variable',
        addVar: 'Add Variable',
        negativePrompt: 'Negative Prompt',
        negativePromptPlaceholder:
          'Describe what you do not want in the image (optional), you can use {varName} to reference variables',
        apiKey: 'API Key',
        advancedHeader: 'Advanced Parameters',
        quality: 'Quality',
        qualityPlaceholder: 'Please select generation quality',
        standard: 'Standard',
        hd: 'HD',
        qualityStandard: 'Standard',
        qualityHD: 'HD',
        style: 'Style',
        stylePlaceholder: 'Please select image style',
        vivid: 'Vivid',
        natural: 'Natural',
        styleVivid: 'Vivid',
        styleNatural: 'Natural',
        seed: 'Seed',
        seedPlaceholder: '-1 for random',
        steps: 'Steps',
        cfgScale: 'CFG Scale',
        outputFormat: 'Output Format',
        outputFormatPlaceholder: 'Please select output format',
        url: 'URL Link',
        base64: 'Base64 Encoding',
        timeout: 'Timeout (s)',
        apiHeader: 'API Configuration',
        apiKeyPlaceholder:
          'Please enter API key (optional, uses global config by default)',
        endpoint: 'API Endpoint',
        endpointPlaceholder:
          'Please enter API endpoint (optional, uses default)',
        maxRetries: 'Max Retries',
        retryDelay: 'Retry Delay (s)',
        outputVars: 'Output Variables',
      },
      image_to_text: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select image to text configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        providerHeader: 'Provider Configuration',
        provider: 'Provider',
        providerPlaceholder: 'Select Image to Text Provider',
        model: 'Model',
        modelPlaceholder: 'Select Model',
        customModel: 'Custom Model',
        inputHeader: 'Image Input',
        imageSource: 'Image Source',
        imageSourcePlaceholder: 'Please select image source',
        url: 'URL Address',
        base64: 'Base64 Data',
        file: 'Local File',
        variable: 'From Variable',
        imageUrl: 'Image URL',
        imageUrlPlaceholder:
          'Enter image URL address. Enter $ to select variables',
        urlVarPlaceholder: 'Enter URL address or select variable',
        base64Placeholder: 'Enter Base64 encoded image data',
        base64VarPlaceholder: 'Enter Base64 data or select variable',
        base64Image: 'Base64 Image',
        filePathPlaceholder: 'Enter image file path on server',
        imageVar: 'Image Variable',
        imageVarPlaceholder: 'Select variable containing image data',
        comparisonDivider: 'Comparison Images',
        table: {
          source: 'Source',
          value: 'Value',
          valuePlaceholder: 'Enter URL or Base64',
          selectVarPlaceholder: 'Enter URL or select variable',
        },
        addImage: 'Add Comparison Image',
        addVar: 'Add Variable',
        promptHeader: 'Prompt Configuration',
        systemPrompt: 'System Prompt',
        systemPromptPlaceholder:
          'Please enter system prompt to set AI role and behavior rules',
        userPrompt: 'User Prompt',
        userPromptPlaceholder:
          'Enter user prompt, describe what analysis you want the model to perform',
        promptVar: 'Prompt from Variable',
        promptVarPlaceholder: 'Select variable containing prompt',
        ocrHeader: 'OCR Configuration',
        language: 'Recognition Language',
        autoDetect: 'Auto Detect',
        zh: 'Chinese',
        en: 'English',
        ja: 'Japanese',
        ko: 'Korean',
        detectDirection: 'Detect Direction',
        returnPosition: 'Return Position',
        positionHint:
          'If enabled, returns coordinate positions for each text block',
        detectionHeader: 'Detection Configuration',
        categories: 'Detection Categories',
        categoriesPlaceholder:
          'Enter object categories to detect and press Enter',
        categoriesHint: 'Common categories: person, car, dog, cat, face, text',
        confidence: 'Confidence Threshold',
        returnBBox: 'Return Bounding Boxes',
        paramsHeader: 'Model Parameters',
        temperature: 'Temperature',
        maxTokens: 'Max Tokens',
        detail: 'Image Detail Level',
        auto: 'Auto',
        low: 'Low',
        high: 'High',
        detailHint:
          'High detail consumes more tokens but provides more accurate recognition',
        apiHeader: 'API Configuration',
        apiKeyPlaceholder: 'Enter API Key',
        endpointPlaceholder: 'Custom API Endpoint (optional)',
        timeout: 'Timeout (s)',
        outputHeader: 'Output Variables',
        outputVars: 'Output Variables',
        apiKey: 'API Key',
        endpoint: 'API Endpoint',
        providers: {
          aliyun: 'Aliyun (Qwen-VL)',
          tencent: 'Tencent Cloud',
          baidu: 'Baidu Cloud (ERNIE)',
          local: 'Local Model',
        },
        advancedHeader: 'Advanced Settings',
      },
      voiceClone: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select voice clone configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        provider: 'Service Provider',
        providerPlaceholder: 'Please select service provider',
        operation: 'Operation Type',
        operationPlaceholder: 'Please select operation type',
        operations: {
          create: 'Create Voice Clone',
          synthesize: 'Synthesize with Clone',
          delete: 'Delete Voice Clone',
          list: 'List Cloned Voices',
        },
        voiceName: 'Voice Name',
        voiceNamePlaceholder: 'Please enter cloned voice name',
        voiceNameVarPlaceholder: 'Enter voice name or select variable',
        audioSource: 'Audio Source',
        audioSourcePlaceholder: 'Please select audio source',
        audioVar: 'Audio Variable',
        audioVarPlaceholder: 'Select output variable from predecessor node',
        description: 'Voice Description',
        descriptionPlaceholder: 'Please enter voice description (optional)',
        descriptionVarPlaceholder:
          'Enter voice description or select variable (optional)',
        voiceId: 'Voice ID',
        voiceIdPlaceholder: 'Please enter cloned voice ID',
        voiceIdVarPlaceholder: 'Enter voice ID or select variable',
        deleteIdPlaceholder: 'Please enter cloned voice ID to delete',
        text: 'TTS Text',
        textPlaceholder:
          'Please enter the text to be synthesized, you can use {varName} to reference variables defined above',
        textHint: 'Use {varName} syntax to insert variables',
        textVars: 'Text Variables',
        textVarValuePlaceholder: 'Enter value or select variable',
        addVar: 'Add Variable',
        audioFormat: 'Audio Format',
        audioFormatPlaceholder: 'Please select output format',
        advancedHeader: 'Advanced Settings',
        apiKey: 'API Key',
        apiKeyPlaceholder:
          'Please enter API key (optional, uses global config by default)',
        endpoint: 'API Endpoint',
        endpointPlaceholder:
          'Please enter API endpoint (optional, uses default)',
        speed: 'Speed',
        pitch: 'Pitch',
        inputVars: 'Input Variables',
        outputVars: 'Output Variables',
      },
      tokenizer: {
        inputVars: 'Input Variables',
        configSelectorHeader: 'Configuration',
        configHeader: 'Model Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select tokenizer model configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        model: 'Model',
        modelPlaceholder: 'Please select model',
        mode: 'Mode',
        modePlaceholder: 'Please select mode',
        modes: {
          split: 'Split',
          count: 'Count',
          analyze: 'Analyze',
        },
        outputVars: 'Output Variables',
      },
      videoParser: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select video parser configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        emptyDescription: 'No configuration',
        videoUrl: 'Video URL',
        base64Video: 'Base64 Video',
        videoUrlVarPlaceholder: 'Enter URL address or select variable',
        base64VideoVarPlaceholder: 'Enter Base64 data or select variable',
        promptVarValuePlaceholder: 'Enter value or select variable',
        addVar: 'Add Variable',
        basicConfig: 'Basic Configuration',
        taskType: 'Task Type',
        taskTypePlaceholder: 'Select task type',
        taskUnderstanding: 'Video Understanding',
        taskSummarize: 'Video Summarize',
        videoInput: 'Video Input',
        videoSource: 'Video Source',
        videoSourcePlaceholder: 'Please select video source',
        urlAddress: 'URL',
        base64Encode: 'Base64',
        promptConfig: 'Prompt Configuration',
        promptPlaceholder:
          'Enter prompt to describe what analysis you want for the video, use {varName} to reference prompt variables',
        promptHint:
          'Use {varName} syntax to insert prompt variables, e.g.: Analyze {subject} in the video',
        frameConfig: 'Frame Extraction',
        frameInterval: 'Frame Interval (s)',
        frameIntervalPlaceholder: '1.0',
        maxFrames: 'Max Frames',
        maxFramesPlaceholder: '10',
        startTime: 'Start Time (s)',
        startTimePlaceholder: '0',
        endTime: 'End Time (s)',
        endTimePlaceholder: 'End of video',
        extractKeyframesOnly: 'Extract Keyframes Only',
        analysisConfig: 'Analysis Configuration',
        recognitionLanguage: 'Recognition Language',
        selectLanguage: 'Select language',
        autoDetect: 'Auto Detect',
        zh: 'Chinese',
        en: 'English',
        ja: 'Japanese',
        ko: 'Korean',
        es: 'Spanish',
        fr: 'French',
        de: 'German',
        detectCategories: 'Detection Categories',
        detectCategoriesPlaceholder: 'Enter category and press Enter',
        confidenceThreshold: 'Confidence Threshold',
        enableTimestamp: 'Enable Timestamp',
        modelParams: 'Model Parameters',
        temperature: 'Temperature',
        maxTokens: 'Max Tokens',
        maxTokensPlaceholder: '2000',
        advancedConfig: 'Advanced Configuration',
        timeout: 'Timeout (s)',
        timeoutPlaceholder: '300',
        maxRetries: 'Max Retries',
        maxRetriesPlaceholder: '2',
        retryDelay: 'Retry Delay (s)',
        retryDelayPlaceholder: '2',
        outputVars: 'Output Variables',
      },
      videoGeneration: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select video generation configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        inputMode: 'Input Mode',
        inputModePlaceholder: 'Select input mode',
        inputModeText: 'Text',
        inputModeImage: 'Image',
        prompt: 'Prompt',
        promptPlaceholder: 'Enter text description for the video',
        imageUrl: 'Image URL',
        imageUrlPlaceholder:
          'Enter image URL for image-to-video mode. Enter $ to select variables',
        imagePrompt: 'Image Prompt',
        imagePromptPlaceholder:
          'Optional text prompt to guide image-to-video generation',
        duration: 'Duration (s)',
        durationPlaceholder: '5',
        resolution: 'Resolution',
        resolutionPlaceholder: 'Select output resolution',
        size1280x720: '1280x720',
        size1920x1080: '1920x1080',
        watermark: 'Watermark',
        promptExtend: 'Prompt Extension',
        outputVars: 'Output Variables',
      },
      gen3d: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select 3D generation configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        basicHeader: 'Basic Configuration',
        inputMode: 'Input Mode',
        inputModePlaceholder: 'Select input mode',
        inputModeImage: 'Image to 3D',
        inputModeText: 'Text to 3D',
        imageUrl: 'Image URL',
        imageUrlPlaceholder:
          'Image URL for image-to-3D mode. Supports JPG, PNG, WEBP. Enter $ to select variables',
        prompt: 'Prompt',
        promptPlaceholder:
          'Text description for the 3D model. Required for text-to-3D.',
        outputFormat: 'Output Format',
        outputFormatPlaceholder: 'Select output format',
        formatGlb: 'GLB (Recommended)',
        formatObj: 'OBJ',
        formatFbx: 'FBX',
        formatPly: 'PLY',
        textureQuality: 'Texture Quality',
        textureQualityPlaceholder: 'Select texture quality',
        qualityLow: 'Low',
        qualityMedium: 'Medium',
        qualityHigh: 'High',
        withTexture: 'Generate Texture',
        seed: 'Random Seed',
        seedPlaceholder: '0 for random',
        outputVars: 'Output Variables',
      },
    },
    flow: {
      iterator: {
        name: 'Iterator',
        description:
          'Iterate over array, execute loop body for each element, automatically collect results',
        iterationSettings: 'Iteration Settings',
        arrayVar: 'Array Variable',
        arrayVarPlaceholder: 'Select array to iterate',
        iterationVars: 'Iteration Variables',
        itemVarName: 'Item Variable Name',
        itemVarNamePlaceholder: 'item',
        itemVarNameTooltip:
          'Variable name to reference current element in loop body',
        indexVarName: 'Index Variable Name',
        indexVarNamePlaceholder: 'index',
        indexVarNameTooltip:
          'Variable name to reference current index in loop body',
        elementSubFields: 'Element Sub Fields',
        elementSubFieldsTooltip:
          'When element is an object, specify sub field names to expose',
        elementSubFieldsPlaceholder: 'Enter field name, press Enter to add',
        executionConfig: 'Execution Configuration',
        parallelExecution: 'Parallel Execution',
        maxConcurrency: 'Max Concurrency',
        errorHandling: 'Error Handling',
        errorStrategies: {
          continue: 'Continue',
          stop: 'Stop Iteration',
        },
        outputVars: 'Output Variables',
      },
      conditional: {
        addBranch: 'Add Branch',
        defaultBranch: 'Default Branch',
        branchIndex: 'Branch {index}',
        delete: 'Delete',
      },
      loop: {
        loopSettings: 'Loop Settings',
        loopType: 'Loop Type',
        loopTypePlaceholder: 'Select loop type',
        loopTypes: {
          count: 'Count',
          while: 'Condition',
        },
        iteratorTip: 'To iterate over an array, use the "Iterator" node',
        loopCount: 'Loop Count',
        loopCountVar: 'Count / Variable',
        countOrVarPlaceholder: 'Enter count or select variable',
        loopCondition: 'Loop Condition',
        loopConditionPlaceholder: 'Enter condition expression',
        conditionExtra:
          'You can use middle variables and condition variables; loop continues when condition is true',
        conditionVar: 'Condition Variables',
        addConditionVar: 'Add Condition Variable',
        safetyLimit: 'Safety Limit',
        maxIterations: 'Max Iterations',
        maxIterationsPlaceholder: '100',
        allowInfiniteLoop: 'Allow Infinite Loop',
        middleVars: 'Middle Variables',
        middleVarsDesc:
          'Middle variables are initialized at loop start, can be read and modified each iteration, final value after loop is output',
        varNamePlaceholder: 'Variable name',
        typePlaceholder: 'Type',
        types: {
          string: 'String',
          number: 'Number',
          boolean: 'Boolean',
          array: 'Array',
          object: 'Object',
        },
        initialValuePlaceholder: 'Initial value',
        addMiddleVar: 'Add Middle Variable',
        executionConfig: 'Execution Config',
        errorHandling: 'Error Handling',
        errorStrategies: {
          continue: 'Continue',
          stop: 'Stop Loop',
        },
        outputVars: 'Output Variables',
      },
      aggregator: {
        aggregatorGroup: 'Aggregation Group',
        placeholder: 'Enter aggregated variable name',
        inputVars: 'Input Variables',
        addInputVar: '+ New Input Variable',
        varFormat: 'Aggregation Format (Optional)',
        varFormatPlaceholder: 'e.g., {var1}_{var2}',
        addGroup: '+ New Group',
        outputVars: 'Output Variables',
        tableName: 'Variable Name',
        tableType: 'Variable Type',
        tableFormat: 'Format',
      },
      humanInput: {
        taskInfo: 'Task Information',
        taskTitle: 'Task Title',
        taskTitlePlaceholder: 'Enter task title',
        taskDesc: 'Task Description',
        taskDescPlaceholder: 'Task instructions',
        operationInstructions: 'Operation Instructions',
        operationInstructionsPlaceholder: 'Guidelines for the assignee',
        formFields: 'Form Fields',
        fieldPrefix: 'Field',
        unnamed: 'Unnamed',
        fieldName: 'Field Name',
        fieldNamePlaceholder: 'Internal field name (English)',
        fieldLabel: 'Display Label',
        fieldLabelPlaceholder: 'Label shown to user',
        fieldType: 'Field Type',
        types: {
          text: 'Text',
          textarea: 'Textarea',
          number: 'Number',
          select: 'Select',
          radio: 'Radio',
          checkbox: 'Checkbox',
          date: 'Date',
          datetime: 'DateTime',
          file: 'File Upload',
          boolean: 'Boolean',
        },
        required: 'Required',
        placeholder: 'Placeholder',
        placeholderInput: 'Input placeholder text',
        defaultValue: 'Default Value',
        defaultValuePlaceholder: 'Field default value',
        options: 'Options',
        optionsPlaceholder: 'Enter option and press Enter',
        addField: 'Add Field',
        assignConfig: 'Assignment Configuration',
        assignee: 'Assignee',
        assigneePlaceholder: 'Enter assignee email and press Enter',
        assigneeFromVar: 'Get Assignee from Variable',
        assigneeVarPlaceholder: 'Select variable containing assignee list',
        allowReassign: 'Allow Reassignment',
        allowReject: 'Allow Rejection',
        notifyConfig: 'Notification Configuration',
        notifyType: 'Notification Method',
        notifyTypes: {
          none: 'None',
          email: 'Email',
          webhook: 'Webhook',
          sms: 'SMS',
          dingtalk: 'DingTalk',
          feishu: 'Feishu',
        },
        notifyEndpoint: 'Notification Endpoint',
        notifyEndpointPlaceholder: 'Email/URL/Phone, etc.',
        timeoutConfig: 'Timeout Configuration',
        timeoutSeconds: 'Timeout (Seconds)',
        defaultTimeoutTip: 'Default 24 hours (86400s)',
        outputVars: 'Output Variables',
        formStyle: 'Form Style',
        layout: 'Layout',
        layouts: {
          vertical: 'Vertical',
          horizontal: 'Horizontal',
          inline: 'Inline',
        },
        labelWidth: 'Label Width',
        submitText: 'Submit Button',
        rejectText: 'Reject Button',
        cancelText: 'Cancel Button',
        fieldTypeGroups: {
          basic: 'Basic Types',
          dateTime: 'Date & Time',
          fileTypes: 'File Types',
          advancedTypes: 'Advanced Types',
        },
        fieldTypes: {
          time: 'Time',
          rating: 'Rating',
          json: 'JSON Editor',
          image: 'Image Upload',
        },
        readonly: 'Readonly',
        hidden: 'Hidden',
        fieldDesc: 'Field Description',
        fieldDescPlaceholder: 'Detailed description for the field (optional)',
        notifyConfigLabel: 'Notification Config',
        selectNotifyConfig: 'Select notification config',
        noNotifyConfig: 'No notification config available',
        notifyTypeNone: 'None',
        notifyTypeEmail: 'Email',
        notifyTypeDingtalk: 'DingTalk',
        notifyTypeFeishu: 'Feishu',
        notifyTypeWechat: 'WeChat Work',
        notifyTypeWebhook: 'Webhook',
        notifyTypeSms: 'SMS',
        emailProvider: 'Email Provider',
        emailProviderPlaceholder: 'Select provider for quick configuration',
        customConfig: 'Custom Configuration',
        smtpServer: 'SMTP Server',
        port: 'Port',
        isHtml: 'HTML Format',
        username: 'Username',
        usernamePlaceholder: 'Login username or email',
        password: 'Password/App Key',
        passwordPlaceholder: 'Password or app-specific password',
        passwordTip: 'Some email providers require an app-specific password',
        from: 'From Email',
        fromName: 'From Name',
        subject: 'Email Subject',
        notifyTemplate: 'Notification Template',
        notifyTemplatePlaceholder:
          'Supports variables: {{title}}, {{description}}, {{assignees}}',
        dingtalkWebhook: 'DingTalk Robot Webhook',
        dingtalkWebhookTip:
          'Group Settings → Smart Group Assistant → Add Robot → Custom → Copy Webhook URL',
        feishuWebhook: 'Feishu Robot Webhook',
        feishuWebhookTip:
          'Group Settings → Group Robots → Add Robot → Custom Robot → Copy Webhook URL',
        wechatWebhook: 'WeChat Work Robot Webhook',
        wechatWebhookTip:
          'Group Chat → Menu (Top Right) → Add Group Robot → Create Robot → Copy Webhook URL',
        webhookTip:
          'Task information will be sent in JSON format via POST request to this address',
      },
      subworkflow: {
        configHeader: 'Sub-workflow Config',
        subworkflow: 'Sub-workflow',
        subworkflowPlaceholder: 'Select sub-workflow',
        viewConfig: 'View Config',
        version: 'Version',
        versionPlaceholder: 'Select version',
        latestVersion: 'latest',
        latestVersionDesc:
          'latest means automatically select the latest published version for each run',
        inputMapping: 'Input Mapping',
        outputMapping: 'Output Mapping',
        mappingPrefix: 'Mapping',
        outputMappingPrefix: 'Output Mapping',
        sourceVar: 'Source Variable',
        targetVar: 'Target Variable',
        targetVarPlaceholder: 'Enter target variable name',
        alias: 'Alias',
        aliasPlaceholder: 'Enter alias',
        defaultValue: 'Default Value',
        defaultValuePlaceholder: 'Enter default value',
        required: 'Required',
        addInputMapping: 'Add Input Mapping',
        addOutputMapping: 'Add Output Mapping',
        execConfig: 'Execution Config',
        timeout: 'Timeout (s)',
        errorHandling: 'Error Handling',
        errorHandlingPlaceholder: 'Select error handling strategy',
        maxRetries: 'Max Retries',
        unnamedNode: 'Unnamed Node',
        loadVersionError: 'Failed to load version list:',
      },
      wait: {
        waitType: 'Wait Type',
        waitTypePlaceholder: 'Select wait type',
        waitTypes: {
          time: 'Fixed Time',
          until: 'Until Specific Time',
          webhook: 'Webhook Callback',
          event: 'Event Trigger',
          approval: 'Human Approval',
        },
        timeConfig: 'Time Config',
        waitSeconds: 'Seconds',
        waitMilliseconds: 'Milliseconds',
        targetTime: 'Target Time',
        webhookConfig: 'Webhook Config',
        webhookId: 'Webhook ID',
        webhookIdPlaceholder: 'Unique identifier',
        webhookSecret: 'Webhook Secret',
        webhookSecretPlaceholder: 'Optional secret for verification',
        callbackUrl: 'Callback URL:',
        eventConfig: 'Event Config',
        eventName: 'Event Name',
        eventNamePlaceholder: 'Name of event to listen for',
        eventCondition: 'Event Condition',
        eventConditionPlaceholder: 'Optional filtering expression',
        approvalConfig: 'Approval Config',
        approvalTitle: 'Approval Title',
        approvalTitlePlaceholder: 'Enter title',
        approvalDesc: 'Approval Description',
        approvalDescPlaceholder: 'Enter description',
        approver: 'Approvers',
        approverPlaceholder: 'Enter email and press Enter',
        minApprovals: 'Min Approvals Required',
        notifyType: 'Notification Method',
        notifyTypes: {
          email: 'Email',
          webhook: 'Webhook',
          sms: 'SMS',
        },
        notifyUrl: 'Notify URL',
        notifyUrlPlaceholder: 'Webhook notification URL',
        timeoutConfig: 'Timeout Config',
        timeoutSeconds: 'Timeout (Seconds)',
        timeoutTip: 'Maximum wait time, continue after timeout',
        outputVars: 'Output Variables',
      },
      streamWait: {
        inputVars: 'Input Variables',
        timeout: 'Timeout (Seconds)',
        outputVars: 'Output Variables',
      },
    },
    database: {
      common: {
        noConfigConfigured:
          'No configuration available, please create one first',
        operationType: 'Operation Type',
        operationPlaceholder: 'Please select operation type',
        tableName: 'Table Name',
        tableNamePlaceholder: 'Please enter table name',
        tableSelectPlaceholder: 'Please select table name',
        condition: 'Condition',
        conditionPlaceholder: 'Please enter WHERE condition',
        data: 'Data',
        sql: 'SQL Statement',
        maxResults: 'Max Results',
        database: 'Database',
        databasePlaceholder: 'Please select database',
        databaseInstance: 'Database Instance',
        databaseInstancePlaceholder: 'Please select database instance',
        inputVars: 'Input Variables',
        outputVars: 'Output Variables',
        offlineMode: 'Offline Mode',
        operations: {
          create_database: 'Create Database',
          list_databases: 'List Databases',
          create_table: 'Create Table',
          insert: 'Insert',
          update: 'Update',
          delete: 'Delete',
          query: 'Query',
          execute: 'Execute SQL',
          count: 'Count',
          insert_vector: 'Insert Vector',
          create_vector_index: 'Create Vector Index',
          search_cosine: 'Vector Search',
          search: 'Vector Search',
          hybrid_search: 'Hybrid Search',
          insert_record: 'Insert Record',
          list_tables: 'List Tables',
          set: 'Set',
          get: 'Get',
          incr: 'Increment',
          exists: 'Exists',
          ttl: 'Get TTL',
          hget: 'Hash Get',
          hset: 'Hash Set',
          hgetall: 'Hash Get All',
          lpush: 'List LPush',
          rpush: 'List RPush',
          lrange: 'List LRange',
          create_collection: 'Create Collection',
          drop_collection: 'Drop Collection',
          has_collection: 'Has Collection',
          list_collections: 'List Collections',
          load_collection: 'Load Collection',
          release_collection: 'Release Collection',
          create_index: 'Create Index',
          flush: 'Flush',
        },
      },
      mysql: {
        noDatabaseConfigured: 'No database configured in this workspace',
        oneClickDeploy: 'One-Click Deploy',
        externalConfiguration: 'External Configuration',
        managed: 'Managed',
        external: 'External',
      },
      milvus: {
        configHeader: 'MiLvus Operation',
        config: 'Configuration',
        configPlaceholder: 'Please select Milvus database configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        collectionName: 'Collection Name',
        collectionPlaceholder: 'Please enter collection name',
        partitionName: 'Partition Name',
        partitionPlaceholder: 'Please enter partition name',
        description: 'Description',
        descriptionPlaceholder: 'Please enter description',
        shardsNum: 'Shards Number',
        shardsNumPlaceholder: 'Please enter shards number',
        fields: 'Fields',
        fieldName: 'Name',
        fieldNamePlaceholder: 'Please enter name',
        fieldType: 'Type',
        fieldTypePlaceholder: 'Please select type',
        isPrimaryKey: 'Primary Key',
        isAutoId: 'Auto ID',
        maxLength: 'Max Length',
        dimension: 'Dimension',
        lengthPlaceholder: 'Please enter length',
        addField: 'Add Field',
        vectorField: 'Vector Field',
        vectorFieldPlaceholder: 'Please enter vector field name',
        indexType: 'Index Type',
        indexTypePlaceholder: 'Please select index type',
        metricType: 'Metric Type',
        metricTypePlaceholder: 'Please select metric type',
        searchParams: 'Search Params',
        topK: 'TopK',
        topKPlaceholder: 'Please enter TopK',
        lists: 'Lists',
        m: 'M',
        efConstruction: 'EF Construction',
        partitionPlaceholderOptional: 'Please enter partition name (optional)',
        outputFields: 'Output Fields',
        outputFieldsPlaceholder: 'Please enter output fields, comma separated',
        deleteExpression: 'Delete Expression',
        deleteExpressionPlaceholder: 'e.g., id in [1, 2, 3]',
        deleteExpressionTip:
          'Use Milvus expression syntax to specify data to delete',
        queryExpression: 'Query Expression',
        queryExpressionPlaceholder: 'e.g., id >= 0',
        queryExpressionTip:
          'Use Milvus expression syntax, leave empty to query all',
        offset: 'Offset',
        limit: 'Limit',
      },
      postgres: {
        configHeader: 'PostgreSQL Operation',
        config: 'Configuration',
        configPlaceholder: 'Please select PostgreSQL database configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        columnName: 'Column Name',
        columnNamePlaceholder: 'Please enter vector column name',
        limit: 'Limit',
        metricType: 'Metric Type',
        metricTypePlaceholder: 'cosine / euclidean / dotproduct',
        expression: 'Filter Expression',
        expressionPlaceholder: 'e.g. category = {category} AND score > 0.5',
        textColumn: 'Text Column',
        textColumnPlaceholder: 'Text column for hybrid search',
        textQuery: 'Text Query',
        textQueryPlaceholder: 'Variable for hybrid search text query',
        textWeight: 'Text Weight',
        vectorWeight: 'Vector Weight',
        sqlPlaceholder: 'Enter SQL with {var_name} placeholders',
        indexType: 'Index Type',
        indexTypePlaceholder: 'Please select index type',
        lists: 'Lists',
        m: 'M',
        efConstruction: 'EF Construction',
      },
      redis: {
        configHeader: 'Redis Operation',
        noDatabaseConfigured: 'No Redis database configured in this workspace',
        field: 'Field',
        fieldFormat: 'Field Format',
        fieldFormatPlaceholder:
          'Enter field format, Enter $ to select variable',
        fieldFormatTip: 'Variable name in {}, e.g., {field1}_{field2}',
        key: 'Key',
        keyFormat: 'Key Format',
        keyFormatPlaceholder: 'Enter key format, Enter $ to select variable',
        keyFormatTip: 'Variable name in {}, e.g., {key1}_{key2}',
        value: 'Value',
        maxCount: 'Max Count',
        start: 'Start',
        stop: 'Stop',
        stopTip: '-1 means end of list',
        expiration: 'Expiration',
        seconds: 's',
      },
      sqlite: {
        conditionTip: "For example: WHERE DATE(created_at) = '{date}'",
        dataTip:
          'Supports splicing variables, such as: aaa_{var_name};\nIf you do not want to set a null value, you should delete the data row, otherwise it will be set to an empty string',
      },
      byteHouse: {
        config: 'Configuration',
        configPlaceholder: 'Please select ByteHouse database configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
      },
    },
    io: {
      common: {
        configHeader: 'Configuration',
        advancedConfig: 'Advanced Configuration',
        sendConfig: 'Send Configuration',
        inputVars: 'Input Variables',
        outputVars: 'Output Variables',
      },
      cloudStorage: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select cloud storage configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        providerConfig: 'Provider Configuration',
        provider: 'Provider',
        providerPlaceholder: 'Please select cloud storage provider',
        operation: 'Operation Type',
        operationPlaceholder: 'Please select operation',
        authConfig: 'Authentication Configuration',
        pathConfig: 'Path Configuration',
        folder: 'Folder',
        folderPlaceholder:
          'Enter folder path (supports nested variables, e.g., a/b/$[folder1])',
        path: 'Path',
        pathPlaceholder:
          'Enter file or folder path. Enter $ to select variable',
        pathVar: 'Path from Variable',
        pathVarPlaceholder: 'Select variable containing path',
        destPath: 'Destination Path',
        destPathPlaceholder:
          'Enter destination path. Enter $ to select variable',
        destVar: 'Destination Path Variable',
        destVarPlaceholder: 'Select destination path variable',
        uploadConfig: 'Upload Configuration',
        source: 'File Source',
        sources: {
          local: 'Local Upload',
          variable: 'From Variable',
          manual: 'Manual Input',
        },
        localFile: 'Select File',
        selectLocalFile: 'Select Local File',
        remotePath: 'Remote Path',
        remotePathPlaceholder: 'Cloud storage path, e.g., /folder/file.txt',
        fileNameVar: 'File Name Variable',
        fileNameVarPlaceholder: 'Select variable containing file name',
        contentVar: 'Content Variable',
        contentVarPlaceholder: 'Select variable containing file content',
        fileName: 'File Name',
        fileNamePlaceholder: 'Enter file name',
        content: 'Text Content',
        contentPlaceholder: 'Please enter text content',
        overwrite: 'Overwrite Existing',
        createParents: 'Auto Create Parent Directories',
        downloadConfig: 'Download Configuration',
        saveMethod: 'Save Method',
        saveToVar: 'Save to Variable',
        saveToLocal: 'Save to Local',
        localPath: 'Local Path',
        localPathPlaceholder: 'Save path on server',
        outputFormat: 'Output Format',
        formats: {
          base64: 'Base64 Encoding',
          text: 'Plain Text',
          binary: 'Binary Stream',
        },
        listConfig: 'List Configuration',
        recursive: 'Recursive List',
        pattern: 'Match Pattern',
        patternPlaceholder: 'e.g., *.txt, *.pdf',
        limit: 'Max Quantity',
        includeFolders: 'Include Folders',
        sortBy: 'Sort Field',
        sortOrder: 'Sort Order',
        shareConfig: 'Share Configuration',
        password: 'Access Password',
        passwordPlaceholder: 'Optional, leave empty for public',
        expireDays: 'Expiry (Days)',
        expireDaysPlaceholder: '0 means permanently valid',
        accessLimit: 'Access Limit',
        accessLimitPlaceholder: '0 means no limit',
        searchConfig: 'Search Configuration',
        keyword: 'Search Keyword',
        keywordPlaceholder: 'Enter search content',
        keywordVar: 'Keyword Variable',
        keywordVarPlaceholder: 'Keyword from variable',
        fileType: 'File Type',
        fileTypes: {
          folder: 'Folder',
          image: 'Image',
          video: 'Video',
          audio: 'Audio',
          document: 'Document',
        },
        timeout: 'Timeout Seconds',
        retryCount: 'Retry Count',
        providers: {
          aliyun_drive: 'Aliyun Drive',
          baidu_pan: 'Baidu Pan',
          google_drive: 'Google Drive',
          onedrive: 'OneDrive',
          dropbox: 'Dropbox',
          s3: 'AWS S3',
          oss: 'Aliyun OSS',
          cos: 'Tencent COS',
          webdav: 'WebDAV',
        },
        operations: {
          list: 'List Files',
          upload: 'Upload File',
          download: 'Download File',
          delete: 'Delete File',
          move: 'Move/Rename',
          copy: 'Copy File',
          create_folder: 'Create Folder',
          get_info: 'Get Info',
          share: 'Share File',
          search: 'Search Files',
        },
        placeholders: {
          accessToken: 'Enter Access Token',
          refreshToken: 'Enter Refresh Token',
          clientId: 'Enter Client ID',
          clientSecret: 'Enter Client Secret',
          accessKey: 'Enter Access Key',
          secretKey: 'Enter Secret Key',
          region: 'e.g., cn-hangzhou, us-east-1',
          bucket: 'Enter Bucket name',
          endpoint: 'Custom Endpoint (Optional)',
          davHost: 'e.g., https://dav.example.com',
          username: 'Enter username',
          password: 'Enter password',
        },
        sortFields: {
          size: 'File Size',
          modified_time: 'Modified Time',
          name: 'File Name',
        },
        errors: {
          noFile: 'Failed to get file object',
          readFailed: 'File read failed',
        },
        selectFileSuccess: 'File {name} selected',
      },
      webSearch: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select search configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        queryLabel: 'Search Query',
        queryPlaceholder: 'Enter search query or select variable',
        engineHeader: 'Search Engine',
        engine: 'Search Engine',
        enginePlaceholder: 'Select search engine',
        engines: {
          searxng: 'SearXNG (Self-hosted)',
          google: 'Google (API Key required)',
          bing: 'Bing (API Key required)',
        },
        searxngConfig: {
          baseUrl: 'Service URL',
          baseUrlPlaceholder: 'https://your-searxng-instance.com',
          baseUrlExtra:
            'SearXNG is an open-source metasearch engine that requires self-deployment',
          engines: 'Specify Engines',
          enginesPlaceholder: 'Leave empty to use default engines',
          engineGroups: {
            general: 'General Search',
            academic: 'Academic Search',
            news: 'News',
            other: 'Other',
          },
        },
        searchParamsHeader: 'Search Parameters',
        maxResults: 'Max Results',
        timeout: 'Timeout (seconds)',
        language: 'Language',
        timeRange: 'Time Range',
        timeRangeOptions: {
          unlimited: 'Unlimited',
          day: 'Past Day',
          week: 'Past Week',
          month: 'Past Month',
          year: 'Past Year',
        },
        categories: 'Search Categories',
        categoryOptions: {
          general: 'Web',
          images: 'Images',
          news: 'News',
          videos: 'Videos',
          science: 'Science',
        },
        safeSearch: 'Safe Search',
        safeSearchOptions: {
          off: 'Off',
          moderate: 'Moderate',
          strict: 'Strict',
        },
        outputVarsHeader: 'Output Variables',
      },
      file: {
        operationConfig: 'Operation Configuration',
        operation: 'Operation Type',
        operationPlaceholder: 'Select operation type',
        operations: {
          read: 'Read File',
          write: 'Write File',
          append: 'Append to File',
          delete: 'Delete File',
          copy: 'Copy File',
          move: 'Move File',
          exists: 'Check Existence',
          stat: 'Get Info',
          list: 'List Directory',
          mkdir: 'Create Directory',
          compress: 'Compress File',
          decompress: 'Decompress File',
        },
        pathConfig: 'Path Configuration',
        source: 'File Source',
        sources: {
          server: 'Server Path',
          upload: 'Local Upload',
          variable: 'From Variable',
        },
        path: 'File Path',
        pathPlaceholder: 'Enter server file path, e.g., /data/file.txt',
        uploadFile: 'Upload File',
        selectFile: 'Select File',
        pathVar: 'Path from Variable',
        pathVarPlaceholder: 'Select variable containing path',
        destPath: 'Destination Path',
        destPathPlaceholder: 'Destination file path',
        readConfig: 'Read Configuration',
        format: 'File Format',
        encoding: 'File Encoding',
        writeConfig: 'Write Configuration',
        content: 'File Content',
        contentPlaceholder: 'Content to write',
        contentVar: 'Content from Variable',
        contentVarPlaceholder: 'Select variable containing content',
        overwrite: 'Overwrite Existing',
        createDirs: 'Auto Create Directories',
        csvConfig: 'CSV Configuration',
        delimiter: 'Delimiter',
        delimiterPlaceholder: 'Default is comma',
        hasHeader: 'Has Header',
        columns: 'Columns',
        columnsPlaceholder: 'Enter column names and press Enter',
        listConfig: 'List Configuration',
        pattern: 'Pattern',
        patternPlaceholder: 'e.g., *.txt, *.pdf',
        recursive: 'Recursive',
        copyConfig: 'Copy/Move Configuration',
        selectFileSuccess: 'File {name} selected',
      },
      http: {
        requestConfig: 'Request Configuration',
        requestMethod: 'Request Method',
        requestMethodPlaceholder: 'Please select request method',
        authRequired: 'Authentication Required',
        responseConfig: 'Response Configuration',
        statusCode: 'Status Code',
        statusCodePlaceholder: 'Please enter status code',
        headers: 'Response Headers',
        jsonFormat: 'JSON Format',
        streaming: 'Streaming Output',
        input: 'Input',
      },
      message: {
        configHeader: 'Configuration',
        config: 'Configuration',
        configPlaceholder: 'Please select message notification configuration',
        noConfigConfigured:
          'No configuration available, please create one first',
        channelConfig: 'Channel Configuration',
        channel: 'Message Channel',
        channelPlaceholder: 'Select message channel',
        messageContent: 'Message Content',
        to: 'To',
        toPlaceholder: 'Enter recipient and press Enter',
        toVar: 'To from Variable',
        toVarPlaceholder: 'Select variable containing recipient',
        subject: 'Subject',
        subjectPlaceholder: 'Email subject',
        contentType: 'Content Type',
        content: 'Message Content',
        contentPlaceholder: 'Message content, support $ variable replacement',
        emailConfig: 'Email Server Configuration',
        timeout: 'Timeout (Seconds)',
        retryCount: 'Retry Count',
        host: 'SMTP Server',
        hostPlaceholder: 'e.g., smtp.example.com',
        port: 'Port',
        username: 'Username',
        password: 'Password',
        from: 'From Email',
        fromName: 'From Name',
        useTls: 'Use TLS',
        dingtalkConfig: 'DingTalk Robot Configuration',
        accessToken: 'Access Token',
        secret: 'Sign Secret',
        atMobiles: '@Mobile Numbers',
        atMobilesPlaceholder: 'Enter mobile numbers and press Enter',
        atAll: '@All',
        feishuConfig: 'Feishu Robot Configuration',
        webhookUrl: 'Webhook URL',
        wechatConfig: 'WeChat Configuration',
        slackConfig: 'Slack Configuration',
        channelName: 'Channel',
        channelNamePlaceholder: '#channel-name',
        botName: 'Bot Name',
        icon: 'Icon',
        iconPlaceholder: ':robot:',
        telegramConfig: 'Telegram Configuration',
        chatId: 'Chat ID',
        smsConfig: 'SMS Configuration',
        provider: 'Provider',
        signName: 'Sign Name',
        templateCode: 'Template Code',
        webhookConfig: 'Webhook Configuration',
        method: 'HTTP Method',
        async: 'Async Send',
        asyncTip: 'Continue execution without waiting for send result',
        channels: {
          email: 'Email',
          dingtalk: 'DingTalk',
          feishu: 'Feishu',
          wechat: 'WeChat',
          slack: 'Slack',
          telegram: 'Telegram',
          sms: 'SMS',
          webhook: 'Webhook',
        },
        contentTypes: {
          text: 'Plain Text',
          html: 'HTML',
          markdown: 'Markdown',
        },
        smsProviders: {
          aliyun: 'Aliyun',
          tencent: 'Tencent',
        },
      },
      tcp: {
        inputConfig: 'TCP Input Configuration',
        outputConfig: 'TCP Output Configuration',
        protocol: 'Protocol Name',
        protocolPlaceholder: 'Please enter protocol name',
        protocolType: 'Protocol Type',
        protocolTypePlaceholder: 'Please select protocol type',
        identity: 'Identity Field',
        identityPlaceholder: 'Enter field name for connection identity',
        streaming: 'Streaming',
        inputVars: 'Input Variables',
        contentVars: 'Content Variables',
      },
      token: {
        authConfig: 'Authentication Configuration',
        tokenType: 'Token Type',
        tokenTypePlaceholder: 'Please select Token operation',
        modes: {
          generate: 'Generate Token',
          verify: 'Verify Token',
        },
        uid: 'Uid',
        token: 'Token',
      },
      humanInput: {
        taskInfo: 'Task Information',
        taskTitle: 'Task Title',
        taskTitlePlaceholder: 'Enter the name displayed for the task',
        taskDesc: 'Task Description',
        taskDescPlaceholder: 'Describe the task context to the assignee',
        operationInstructions: 'Operation Instructions',
        operationInstructionsPlaceholder:
          'Guide the assignee on how to operate',
        formFields: 'Form Fields',
        fieldPrefix: 'Field',
        unnamed: 'Unnamed',
        fieldName: 'Field ID',
        fieldNamePlaceholder: 'English identifier, e.g., user_name',
        fieldLabel: 'Display Name',
        fieldLabelPlaceholder: 'Display label for the field, e.g., User Name',
        fieldType: 'Field Type',
        required: 'Required',
        fieldDesc: 'Field Description',
        fieldDescPlaceholder: 'Detailed description for the field (optional)',
        placeholder: 'Placeholder',
        placeholderPlaceholder: 'Input box placeholder text',
        defaultValue: 'Default Value',
        defaultValuePlaceholder: 'Field default value',
        options: 'Options',
        optionsPlaceholder: 'Enter option and press Enter, e.g., Option A',
        addField: 'Add Field',
        assignConfig: 'Assignee Configuration',
        assignee: 'Specify Assignees',
        assigneePlaceholder: 'Enter username or ID and press Enter',
        assigneeFromVar: 'Select Assignees from Variable',
        assigneeVarPlaceholder: 'Select variable containing assignee list',
        allowReassign: 'Allow Reassignment',
        allowReject: 'Allow Rejection/Refusal',
        notifyConfig: 'Notification Configuration',
        notifyType: 'Notification Type',
        emailProvider: 'Email Provider',
        emailProviderPlaceholder: 'Select provider for quick configuration',
        customConfig: 'Custom Configuration',
        smtpServer: 'SMTP Server',
        port: 'Port',
        isHtml: 'HTML Format',
        username: 'Username',
        usernamePlaceholder: 'Login username or email',
        password: 'Password/App Key',
        passwordPlaceholder: 'Password or app-specific password',
        passwordTip: 'Some email providers require an app-specific password',
        from: 'From Email',
        fromName: 'From Name',
        subject: 'Email Subject',
        notifyTemplate: 'Notification Template',
        notifyTemplatePlaceholder:
          'Supports variables: {{title}}, {{description}}, {{assignees}}',
        timeoutConfig: 'Timeout Handling',
        timeoutSeconds: 'Timeout (Seconds)',
        defaultTimeoutTip: 'Default unlimited, max 30 days',
        formStyle: 'Form Style',
        layout: 'Layout',
        layouts: {
          vertical: 'Vertical',
          horizontal: 'Horizontal',
          inline: 'Inline',
        },
        labelWidth: 'Label Width',
        submitText: 'Submit Button',
        rejectText: 'Reject Button',
        cancelText: 'Cancel Button',
        outputVars: 'Output Variables',
      },
    },
    trigger: {
      common: {
        config: 'Trigger Configuration',
        type: 'Trigger Type',
        typePlaceholder: 'Please select trigger type',
        advanced: 'Advanced Configuration',
        enabled: 'Enabled',
      },
      schedule: {
        configHeader: 'Trigger Config',
        timezone: 'Timezone',
        timezonePlaceholder: 'Please select timezone',
        triggerTime: 'Trigger Time',
        useVisualPicker: 'Use visual picker',
        useCronExpression: 'Use cron expression',
        frequency: 'Frequency',
        frequencyPlaceholder: 'Please select frequency',
        hourly: 'Hourly',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        onMinute: 'On Minute',
        onMinutePlaceholder: 'Minute (0-59)',
        time: 'Time',
        timePlaceholder: 'Select time',
        weekDays: 'Week days',
        weekDaysPlaceholder: 'Select week days',
        weekDaySun: 'Sunday',
        weekDayMon: 'Monday',
        weekDayTue: 'Tuesday',
        weekDayWed: 'Wednesday',
        weekDayThu: 'Thursday',
        weekDayFri: 'Friday',
        weekDaySat: 'Saturday',
        monthDays: 'Days',
        monthDaysPlaceholder: 'Select days of month',
        lastDay: 'Last day',
        lastDayLabel: 'Last day of month',
        cron: 'Cron Expression',
        cronPlaceholder: '0 9 * * *',
        cronTip:
          'Format: Min Hour Day Month Week\nExample: 0 9 * * * (9 AM daily) | */5 * * * * (Every 5 mins)',
        next5ExecutionTimes: 'Next 5 execution times',
        outputVarsHeader: 'Available Variables',
        hints: {
          cronRequired:
            'Enter a cron expression to preview upcoming run times.',
          cronInvalid: 'A cron expression must contain at least 5 fields.',
          cronPreview:
            'Enter a valid cron expression to preview upcoming run times.',
          visualPreview:
            'Set a frequency and time to preview upcoming run times.',
          weekDaysRequired: 'Select at least one weekday for Weekly frequency.',
          monthDaysRequired:
            'Select at least one day, or enable last day of month.',
        },
      },
      webhook: {
        config: 'Webhook Configuration',
        webhookUrlPlaceholder: 'Please enter Webhook URL',
        path: 'Path',
        pathPlaceholder: '/webhook/your-path',
        webhookUrl: 'Webhook URL',
        method: 'HTTP Method',
        methodPlaceholder: 'Please select HTTP method',
        testRunUrl: 'Test Run URL',
        publishedUrl: 'Published URL',
        copy: 'Copy',
        contentType: 'Content Type',
        contentTypes: {
          json: 'application/json',
          formUrlEncoded: 'application/x-www-form-urlencoded',
          plain: 'text/plain',
          octetStream: 'application/octet-stream',
          multipart: 'multipart/form-data',
        },
        queryParameters: 'Query Parameters',
        headerParameters: 'Header Parameters',
        requestBodyParameters: 'Request Body Parameters',
        variableName: 'Variable Name',
        variableNamePlaceholder: 'Enter variable name',
        authorization: 'Authorization',
        authorizationInQuery: 'Authorization in Query Parameters',
        authorizationInHeader: 'Authorization in header parameters',
        authorizationName: 'Authorization Name',
        authorizationNamePlaceholder: 'Enter authorization name',
        authorizationValue: 'Authorization Value',
        authorizationValuePlaceholder: 'Enter authorization value',
        value: 'Value',
        validatePayload: 'Validate payload',
        validatePayloadTooltip:
          'Enforce strict data matching. Only requests that perfectly align with your query, header and body parameter settings will be allowed to the trigger.',
        outputVars: 'Output Variables',
        addParameter: 'Add Parameter',
      },
    },
    knowledge: {
      noKnowledgeConfigured: 'No knowledge in this workspace',
      toCreateKnowledge: 'To Create Knowledge',
      knowledgePlaceholder: 'Please select knowledge',
      create: {
        nameVar: 'Name Variable',
        nameVarPlaceholder:
          'Please select name variable or enter a fixed value directly',
        descVar: 'Description Variable',
        descVarPlaceholder:
          'Please select description variable or enter a fixed value directly',
      },
      delete: {
        config: 'Delete Configuration',
        docIdVar: 'Document ID Variable',
        docIdVarPlaceholder:
          'Please select document ID variable or enter a fixed value directly',
      },
      es: {
        kbConfig: 'Knowledge Base Configuration',
        kb: 'Knowledge Base',
        kbPlaceholder: 'Please select knowledge base',
        queryConfig: 'Query Configuration',
        queryVar: 'Query Variable',
        queryVarPlaceholder: 'Please select query variable',
        queryType: 'Query Type',
        queryTypePlaceholder: 'Please select query type',
        queryTypes: {
          match: 'Match (Full Text)',
          matchPhrase: 'Match Phrase',
          multiMatch: 'Multi Match',
          queryString: 'Query String',
          bool: 'Bool',
          custom: 'Custom DSL',
        },
        searchFields: 'Search Fields',
        searchFieldsPlaceholder: 'Enter field names and press Enter',
        queryDsl: 'Query DSL',
        queryDslPlaceholder: 'Enter ElasticSearch Query DSL (JSON format)',
        pagination: 'Pagination & Sorting',
        from: 'From',
        size: 'Size',
        sort: 'Sort Configuration',
        sortPlaceholder: 'Enter sort configuration (JSON array)',
        highlight: 'Highlight Configuration',
        enableHighlight: 'Enable Highlight',
        highlightFields: 'Highlight Fields',
        highlightFieldsPlaceholder: 'Enter field names to highlight',
        preTags: 'Pre Tags',
        postTags: 'Post Tags',
      },
      memory: {
        kbId: 'Knowledge Base ID',
        kbIdPlaceholder: 'Please select knowledge base ID',
        item: 'Item',
        tableName: 'Table Name',
        tableNamePlaceholder: 'Please enter table name',
        inputVar: 'Input Variable',
        inputVarPlaceholder: 'Please select input variable',
        defaultValue: 'Default Value',
        defaultValuePlaceholder: 'Please enter default value',
        outputFormat: 'Output Format',
        outputFormatPlaceholder: 'Please enter output format, e.g.: npc_{id}',
        outputVar: 'Output Variable',
        outputVarNamePlaceholder: 'Please enter output variable name',
        addItem: 'Add Search Item',
      },
      document: {
        config: 'Document Configuration',
      },
      search: {
        config: 'Search Configuration',
        searchType: 'Search Type',
        searchTypePlaceholder: 'Please select search type',
        searchTypes: {
          auto: 'Default',
          bm25: 'BM25',
          vector: 'Vector',
          hybrid: 'Hybrid',
          es_default: 'ES Default',
          es_query: 'ES Query',
        },
        kbIdVar: 'Knowledge Base ID Variable',
        kbIdVarPlaceholder:
          'Please select knowledge base ID variable or enter fixed value',
        topK: 'Top K',
        scoreThreshold: 'Score Threshold',
        includeMetadata: 'Include Metadata',
        fusionMethod: 'Fusion Method',
        bm25Weight: 'BM25 Weight',
        vectorWeight: 'Vector Weight',
        rrfConstant: 'RRF Constant K',
        rerankTopK: 'Rerank Top K',
        diversityBoost: 'Diversity Boost',
        normalize: 'Normalize Score',
        rerank: 'Rerank',
        esQueryDsl: 'ES Query DSL',
        esQueryDslTooltip: 'Please enter a valid JSON format ES query',
        metaFilter: 'Metadata Filter',
        checkEsQuery: 'Please check if the ES query is correct',
      },
      upload: {
        config: 'Upload Configuration',
        fileContentVar: 'File Content Variable',
        fileContentVarPlaceholder: 'Please select file content variable',
        filenameVar: 'Filename Variable',
        filenameVarPlaceholder: 'Please select filename variable',
        filePath: 'File Path',
        filePathPlaceholder: 'Optional: Enter file path directly',
        saveLocalCopy: 'Save Local Copy',
        localSavePath: 'Local Save Path',
        localSavePathPlaceholder: 'Optional: Local save path',
      },
      vectorize: {
        config: 'Vectorize Configuration',
        embeddingModel: 'Embedding Model',
        embeddingModelPlaceholder: 'Please enter embedding model name',
        chunkingMethod: 'Chunking Method',
        chunkingMethodPlaceholder: 'Please enter chunking method',
        chunkSize: 'Chunk Size',
        chunkSizePlaceholder: 'Please enter chunk size',
        chunkOverlap: 'Chunk Overlap',
        chunkOverlapPlaceholder: 'Please enter chunk overlap',
      },
    },
    rag: {
      generation: {
        config: 'Generation Configuration',
        modelName: 'Model Name',
        modelNamePlaceholder: 'Please enter model name',
        promptTemplate: 'Prompt Template',
        promptTemplatePlaceholder: 'Please enter prompt template',
        contextVar: 'Context Variable',
        contextVarPlaceholder: 'Please select context variable',
        queryVar: 'Query Variable',
        queryVarPlaceholder: 'Please select query variable',
        temperature: 'Temperature',
        temperaturePlaceholder: 'Please enter temperature',
        maxTokens: 'Max Tokens',
        maxTokensPlaceholder: 'Please enter max tokens',
        systemPrompt: 'System Prompt',
        systemPromptPlaceholder: 'Optional: System prompt',
        streaming: 'Streaming',
      },
      retrieval: {
        config: 'RAG Retrieval Configuration',
        kbIdPlaceholder: 'Please select knowledge base ID or enter fixed value',
        outputFormats: {
          raw: 'Raw',
          formatted: 'Formatted',
          combined: 'Combined',
        },
      },
    },
    code: {
      common: {
        config: 'Code',
        generateTemplate: 'Generate Template',
        timeout: 'Timeout',
        timeoutPlaceholder: 'Execution timeout (seconds)',
        unitSecond: 's',
        varSelectTip: '💡 Type $ to select predecessor node variables',
        template: {
          todo: 'Write your logic here',
        },
      },
      javascript: {
        availableApi: 'Available API',
        input: 'Input',
        output: 'Output',
        helper: 'Helper Functions',
        template: {
          getInput: 'Get input variables',
          processing: 'Processing logic',
          returnResult: 'Return results',
        },
      },
      python: {
        funcTemplate: 'Function Template',
        requirements: 'Requirements',
        requirementsPlaceholder:
          'Enter requirements list and press Enter to add',
        template: {
          inputParams: 'Input Parameters',
          returnValue: 'Return Value',
          none: 'None',
        },
      },
    },
    nodeTypes: {
      categories: {
        ai: 'AI Node',
        byte_house: 'ByteHouse',
        code: 'Code Node',
        data: 'Data Node',
        database: 'Database Node',
        flow: 'Flow Control',
        io: 'Input/Output',
        knowledge: 'Knowledge Base',
        milvus: 'Milvus',
        mysql: 'MySQL',
        postgres: 'PostgreSQL',
        rag: 'RAG Node',
        redis: 'Redis',
        sqlite: 'SQLite',
        trigger: 'Trigger',
      },
      data: {
        names: {
          document_extractor: 'Document Extractor',
          list_operator: 'List Operator',
          template: 'Template',
          transform: 'Transform',
          set: 'Set Variable',
        },
        descriptions: {
          document_extractor:
            'Extract text content from documents of various formats',
          list_operator:
            'Perform operations like filtering, sorting, deduplication, and mapping on list data',
          template: 'Render dynamic content using a template engine',
          transform:
            'Provide data transformation functions like encoding, format conversion, hashing, and encryption',
          set: 'Set workflow variables',
        },
        labels: {
          document_extractor: {
            source: 'Data Source',
            type: 'Document Type',
            input_var: 'Input Variables',
            ocr_enabled: 'Enable OCR',
            extract_images: 'Extract Images',
            extract_metadata: 'Extract Metadata',
            output_vars: 'Output Variables',
          },
          list_operator: {
            operation: 'Operation',
            input_var: 'Input Variables',
            field: 'Field',
            conditions: 'Conditions',
            output_vars: 'Output Variables',
          },
          template: {
            engine: 'Template Engine',
            template: 'Template',
            variables: 'Variables',
            output_format: 'Output Format',
            output_vars: 'Output Variables',
          },
          transform: {
            type: 'Transform Type',
            input_var: 'Input Variables',
            output_vars: 'Output Variables',
          },
          set: {
            values: 'Variable Values',
            mode: 'Set Mode',
            output_vars: 'Output Variables',
          },
        },
      },
      ai: {
        names: {
          llm: 'LLM',
          embedding: 'Embedding',
          tokenizer: 'Tokenizer',
          intent: 'Intent Recognition',
          content_safe: 'LLM Content Safety',
          agent: 'Agent',
          text_to_image: 'Text to Image',
          tts: 'Text to Speech',
          stt: 'Speech to Text',
          voice_clone: 'Voice Clone',
          video_parser: 'Video Parser',
          video_generation: 'Video Generation',
          gen_3d: '3D Model Generation',
          image_to_text: 'Image to Text',
        },
        descriptions: {
          llm: 'Call large language models for text generation',
          embedding: 'Convert text into vector representation',
          tokenizer: 'Perform tokenization on text',
          intent:
            'Used for intent recognition of user input and matching it with preset intent options',
          content_safe: 'Detect content risks in LLM inputs and outputs',
          agent:
            'Intelligent Agent supporting multiple reasoning strategies for complex tasks',
          image_to_text:
            'Visual AI capabilities like Image Parser, OCR, and object detection',
          text_to_image:
            'Generate images using AI, supporting models like DALL-E and Stable Diffusion',
          tts: 'Convert text to speech, supporting multiple voices and languages',
          stt: 'Convert speech to text, supporting multiple languages and formats',
          voice_clone: 'Clone voices or synthesize speech using cloned voices',
          video_parser:
            'Video Parser, summarization, transcription, and object detection capabilities',
          video_generation: 'Generate a video from a text prompt or image.',
          gen_3d:
            'Generate a 3D model from an image or text prompt. Currently only Volcengine is supported.',
        },
        labels: {
          llm: {
            model_name: 'Model Name',
            prompt: 'Prompt',
            temperature: 'Temperature',
            max_tokens: 'Max Tokens',
            streaming: 'Streaming',
            system_prompt: 'System Prompt',
            output_vars: 'Output Variables',
            prompt_vars: 'Prompt Variables',
          },
          embedding: {
            input_vars: 'Input Variables',
            model_name: 'Model Name',
            batch_size: 'Batch Size',
            output_vars: 'Output Variables',
          },
          tokenizer: {
            input_vars: 'Input Variables',
            model: 'Tokenizer Model',
            mode: 'Tokenization Mode',
            output_vars: 'Output Variables',
          },
          agent: {
            strategy: 'Reasoning Strategy',
            task: 'Task Description',
            system_prompt: 'System Prompt',
            max_iterations: 'Max Iterations',
            temperature: 'Temperature',
            timeout: 'Timeout',
            max_tokens: 'Max Tokens',
            tools: 'Available Tools',
            strategy_params: 'Strategy Parameters',
            input_vars: 'Input Variables',
            output_vars: 'Output Variables',
          },
        },
      },
      code: {
        names: {
          javascript: 'JavaScript',
          python: 'Python',
        },
        descriptions: {
          javascript: 'Execute JavaScript code',
          python: 'Execute Python code',
        },
        labels: {
          javascript: {
            code: 'JavaScript Code',
            input_varss: 'Input Variables',
            output_vars: 'Output Variables',
          },
          python: {
            input_varss: 'Input Variables',
            code: 'Python Code',
            python_path: 'Python Path',
            requirements: 'Requirements',
            output_vars: 'Output Variables',
          },
        },
      },
      database: {
        names: {
          mysql: 'MySQL',
          redis: 'Redis',
          sqlite: 'SQLite',
          byte_house: 'ByteHouse',
          postgres: 'PostgreSQL',
          milvus: 'Milvus',
        },
        descriptions: {
          mysql: 'Perform MySQL database operations',
          redis: 'Perform Redis cache operations',
          sqlite: 'Perform SQLite database operations',
          byte_house: 'Perform ByteHouse database operations',
          postgres: 'Perform PostgreSQL vector database operations (pgvector)',
          milvus: 'Perform Milvus vector database operations',
        },
        labels: {
          mysql: {
            operation: 'Operation Type',
            table: 'Table Name',
            condition: 'Condition',
            data: 'Data',
            sql: 'SQL Statement',
            connection: 'Connection Config',
            max_results: 'Max Results',
            output_vars: 'Output Variables',
          },
          redis: {
            operation: 'Operation Type',
            key: 'Key',
            value: 'Value',
            field: 'Field',
            expiration: 'Expiration',
            connection: 'Connection Config',
            output_vars: 'Output Variables',
          },
          postgres: {
            operation: 'Operation Type',
            table_name: 'Table Name',
            column_name: 'Column Name',
            data: 'Data',
            query_vector: 'Query Vector',
            query_vector_var: 'Query Vector Variable',
            limit: 'Limit',
            index_type: 'Index Type',
            index_params: 'Index Parameters',
            connection: 'Connection Config',
            output_vars: 'Output Variables',
          },
          milvus: {
            operation: 'Operation Type',
            collection: 'Collection Name',
            partition: 'Partition Name',
            data: 'Data',
            vector_field: 'Vector Field',
            index_params: 'Index Parameters',
            search_params: 'Search Parameters',
            expression: 'Expression',
            connection: 'Connection Config',
            output_vars: 'Output Variables',
          },
        },
      },
      flow: {
        names: {
          conditional: 'Conditional',
          loop: 'Loop',
          iterator: 'Iterator',
          aggregator: 'Aggregator',
          subworkflow: 'Subworkflow',
          stream_wait: 'Stream Wait',
          wait: 'Wait',
          human_input: 'Human Input',
        },
        descriptions: {
          conditional: 'Execute different branches based on conditions',
          loop: 'Perform loop operations',
          aggregator: 'Aggregate multiple data sources',
          subworkflow: 'Reuse existing workflows',
          stream_wait:
            'Wait for streaming output to complete before continuing',
          wait: 'Pause workflow execution, supporting scheduled, callback, event, and approval waits',
          human_input: 'Pause workflow to wait for human input of form data',
        },
        labels: {
          conditional: {
            condition: 'Condition Expression',
            true_node_id: 'True Branch Node ID',
            false_node_id: 'False Branch Node ID',
            condition_vars: 'Condition Variables',
          },
          loop: {
            loop_type: 'Loop Type',
            count_value: 'Count Value',
            count_var: 'Count Variable',
            condition: 'Condition',
            condition_vars: 'Condition Variables',
            loop_node_id: 'Loop Body Node ID',
            exit_node_id: 'Exit Node ID',
            max_iterations: 'Max Iterations',
            allow_infinite_loop: 'Allow Infinite Loop',
          },
          parallel: {
            branch_node_ids: 'Branch Node ID List',
            join_node_id: 'Join Node ID',
            wait_for_all: 'Wait for All Branches',
            timeout_seconds: 'Timeout (Seconds)',
            result_var: 'Result Variable',
          },
          aggregator: {
            source_vars: 'Source Variable List',
            separator: 'Separator',
            output_format: 'Output Type',
            output_vars: 'Output Variables',
          },
        },
      },
      io: {
        names: {
          http_input: 'HTTP Input',
          http_output: 'HTTP Output',
          tcp_input: 'Websocket Input',
          tcp_output: 'Websocket Output',
          token: 'Token',
          message: 'Message Notification',
          cloud_storage: 'Cloud Storage',
          file: 'File Operation',
          web_search: 'Web Search',
        },
        descriptions: {
          http_input: 'Receive HTTP requests',
          http_output: 'Send HTTP responses',
          tcp_input: 'Receive Websocket messages',
          tcp_output: 'Send Websocket messages',
          token: 'Generate or verify Tokens',
          message:
            'Send message notifications, supporting email, DingTalk, Feishu, WeChat, Slack, etc.',
          cloud_storage:
            'Support operations for Alibaba Cloud Drive, Baidu Netdisk, Google Drive, OneDrive, S3, etc.',
          file: 'Read, write, copy, move, and delete files',
          web_search: 'Search internet content using search engines',
        },
        labels: {
          http_input: {
            path: 'Path',
            method: 'HTTP Method',
            required_params: 'Required Parameters',
            headers: 'Request Headers',
            auth_required: 'Authentication Required',
            output_vars: 'Output Variables',
          },
          http_output: {
            status_code: 'Status Code',
            headers: 'Response Headers',
            content_var: 'Content Variable',
            format_json: 'Format JSON',
          },
          tcp_input: {
            protocol: 'Protocol',
            output_vars: 'Output Variables',
          },
          tcp_output: {
            protocol: 'Protocol',
            content_var: 'Content Variable',
            format_json: 'Format JSON',
            streaming: 'Streaming',
          },
          token: {
            mode: 'Token Operation',
            input_vars: 'Input Variables',
            output_vars: 'Output Variables',
          },
        },
      },
      knowledge: {
        names: {
          kb_search: 'KB Search',
          kb_memory: 'KB Memory',
          kb_es: 'ElasticSearch Search',
          knit_kb_search: 'Knowledge Search',
          knit_kb_doc_create: 'Knowledge Document Create',
        },
        descriptions: {
          kb_search: 'Retrieve relevant content from the knowledge base',
          kb_memory: 'Retrieve relevant content from knowledge base memory',
          kb_es: 'Perform full-text search using ElasticSearch',
          knit_kb_search: 'Search using Knowledge Base',
          knit_kb_doc_create: 'Create Knowledge Document',
        },
        labels: {
          kb_create: {
            name: 'Knowledge Base Name',
            description: 'Description',
            name_var: 'Name Variable',
            desc_var: 'Description Variable',
            output_vars: 'Output Variables',
          },
          kb_upload: {
            knowledge_base_id: 'Knowledge Base ID',
            knowledge_base_id_var: 'Knowledge Base ID Variable',
            file_content_var: 'File Content Variable',
            filename_var: 'Filename Variable',
            file_path: 'File Path',
            save_local_copy: 'Save Local Copy',
            local_save_path: 'Local Save Path',
            output_vars: 'Output Variables',
          },
          kb_search: {
            knowledge_base_id: 'Knowledge Base ID',
            knowledge_base_id_var: 'Knowledge Base ID Variable',
            query_var: 'Query Variable',
            model_name: 'Model Name',
            top_k: 'Top K',
            score_threshold: 'Score Threshold',
            output_vars: 'Output Variables',
            max_results: 'Max Results',
            include_metadata: 'Include Metadata',
          },
          kb_vectorize: {
            document_ids: 'Document List',
            document_ids_var: 'Document ID Variable',
            embedding_model: 'Embedding Model',
            chunking_method: 'Chunking Method',
            chunk_size: 'Chunk Size',
            chunk_overlap: 'Chunk Overlap',
            vector_db_config: 'Vector DB Config',
            output_vars: 'Output Variables',
          },
          kb_delete: {
            document_id: 'Document',
            document_ids_var: 'Document ID Variable',
            output_vars: 'Output Variables',
          },
          knit_kb_search: {
            knowledge: 'Knowledge',
            config_uuid: 'Config UUID',
            config_type: 'Config Type',
            query_var: 'Query Variable',
            page: 'Page',
            page_size: 'Page Size',
            similarity_threshold: 'Similarity Threshold',
            score_threshold: 'Score Threshold',
            vector_similarity_weight: 'Vector Similarity Weight',
            top_k: 'Top K',
            rerank_id: 'Rerank ID',
            keyword: 'Keyword Search',
            highlight: 'Highlight',
            metadata_condition_json: 'Metadata Condition JSON',
            document_ids: 'Document List',
            cross_languages: 'Cross Languages',
            output_vars: 'Output Variables',
          },
          knit_kb_doc_create: {
            knowledge: 'Knowledge',
            content_var: 'Content Variable',
            file_data_var: 'File Data Variable',
            file_name_var: 'File Name Variable',
            file_name: 'File Name',
            parent_path: 'Parent Path',
            output_vars: 'Output Variables',
          },
        },
      },
      rag: {
        labels: {
          retrieval: {
            knowledge_base_id: 'Knowledge Base ID',
            knowledge_base_id_var: 'Knowledge Base ID Variable',
            query_var: 'Query Variable',
            embedding_model: 'Embedding Model',
            top_k: 'Top K',
            output_vars: 'Output Variables',
            output_format: 'Output Format',
          },
          generation: {
            model_name: 'Model Name',
            prompt_template: 'Prompt Template',
            context_var: 'Context Variable',
            query_var: 'Query Variable',
            temperature: 'Temperature',
            max_tokens: 'Max Tokens',
            system_prompt: 'System Prompt',
            streaming: 'Streaming',
            output_vars: 'Output Variables',
          },
        },
      },
      trigger: {
        names: {
          schedule_trigger: 'Schedule Trigger',
          webhook_trigger: 'Webhook Trigger',
        },
        descriptions: {
          schedule_trigger:
            'Trigger workflow based on Cron expression or fixed interval',
          webhook_trigger: 'Trigger workflow via HTTP Webhook',
        },
        labels: {
          schedule_trigger: {
            timezone: 'Timezone',
            schedule_mode: 'Schedule Mode',
            cron: 'Cron Expression',
            frequency: 'Frequency',
            output_vars: 'Output Variables',
          },
          webhook_trigger: {
            path: 'Webhook Path',
            method: 'HTTP Method',
            content_type: 'Content Type',
            query_parameters: 'Query Parameters',
            header_parameters: 'Header Parameters',
            request_body_parameters: 'Request Body Parameters',
            validate_payload: 'Validate Payload',
            output_vars: 'Output Variables',
          },
        },
      },
    },
    workflowGraph: {
      messages: {
        nodeLocked:
          'User {nickname} is editing this node, please try again later',
        layoutFailed: 'Layout optimization failed, please try again later',
        applyAIFailed: 'Failed to apply workflow',
      },
      nodeFallback: 'Node',
      copySuffix: '_Copy',
    },
    workflow: {
      status: {
        success: 'Success',
        completed: 'Completed',
        failed: 'Failed',
        error: 'Error',
        ready: 'Ready',
        waiting: 'Waiting',
        running: 'Running',
        skipped: 'Skipped',
      },
    },
  },
};
